import * as React from 'react'
import { injectIntl, WrappedComponentProps, FormattedMessage } from 'react-intl'

import { Modal, Elements, TextButton } from '@tfo/common'
import classnames from 'classnames'

import './DenyApprovalModal.scss'
import { Grid } from '@material-ui/core'
const { Heading4, Paragraph } = Elements

const DenyApprovalModal: React.FunctionComponent<Modal.ModalProps & {
	companyName: string
} & WrappedComponentProps> = props => {
	const { onCloseClick, onConfirmClick, onDenyClick, companyName } = props

	return (
		<Modal.Modal
			className={classnames('DenyApprovalModal')}
			onDenyClick={onDenyClick}
			onConfirmClick={onConfirmClick}
			onCloseClick={onCloseClick}>
			<Grid container className="DenyApprovalModal__Inner" direction="column">
				<Grid className={'DenyApprovalModal__Header'} item>
					<Heading4 className="DenyApprovalModal__Heading4">
						<FormattedMessage id="individual.denyApproval.heading" />
					</Heading4>
				</Grid>
				<Grid className="DenyApprovalModal__ScrollingContent" item>
					<Paragraph className="DenyApprovalModal__Paragraph">
						<FormattedMessage
							id="individual.denyApproval.body"
							values={{ companyName: companyName }}
						/>
					</Paragraph>
				</Grid>
				<Grid
					item
					container
					className="DenyApprovalModal__TextButton"
					direction="row">
					<Grid item>
						<TextButton
							secondary={true}
							className="DenyApprovalModal__TextButton--left"
							onClick={() => {
								if (onDenyClick) {
									onDenyClick()
								}
							}}>
							<FormattedMessage id="individual.common.btn.cancel" />
						</TextButton>
					</Grid>
					<Grid item>
						<TextButton
							className=" DenyApprovalModal__TextButton--right"
							onClick={() => {
								if (onConfirmClick) {
									onConfirmClick()
								}
							}}>
							<FormattedMessage id="individual.common.btn.confirm" />
						</TextButton>
					</Grid>
				</Grid>
			</Grid>
		</Modal.Modal>
	)
}

export default injectIntl(DenyApprovalModal)
